// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__4OVeP","loader__content":"Loader_loader__content__4Tl8L","load8":"Loader_load8__qrdb5"};